import { AvatarSizes, getEmojiUrl, themeEmoji } from "@skailer-com/uikit";
import { Editor } from "@tiptap/react";

export function insertEmoji(editor: Editor, emoji: string) {
  const size: keyof AvatarSizes = "md";
  const dataSize: string = themeEmoji.variants.size[size];

  editor
    .chain()
    .focus()
    .insertContent([
      {
        type: "emojiImage",
        attrs: {
          src: getEmojiUrl(emoji, size),
          alt: emoji,
          "data-emoji": "true",
          class: dataSize,
        },
      },
    ])
    .run();
}
